import React, { useState, useEffect } from "react";
import MetaTags from "react-meta-tags";
import {
  Col,
  Container,
  Row,
  Card,
  CardBody,
  CardTitle,
  Form,
  FormGroup,
  Table,
  Input,
  Button,
  Label,
  InputGroup,
  UncontrolledButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

// Redux
import { getDailyList } from "connection/backend";
import { get_file } from "connection/api";

//Import Flatepicker
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import { Spanish } from "flatpickr/dist/l10n/es";

//Import Breadcrumb
import Breadcrumb from "components/Common/Breadcrumb";
import Loader from "components/Common/Loader";

const DailyList = () => {
  const URL = process.env.REACT_APP_URL;
  const [loading, setLoading] = useState(false);
  const [tickets, setTickets] = useState([]);

  const fechaActual = new Date();
  const dia = fechaActual.getDate();
  const mes = fechaActual.getMonth() + 1;
  const anio = fechaActual.getFullYear();

  const fechaString = `${anio}-${mes < 10 ? "0" + mes : mes}-${
    dia < 10 ? "0" + dia : dia
  }`;

  const [createdDate, setCreatedDate] = useState(fechaString);

  const onChange = (e) => {
    setCreatedDate(e.target.value);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    getData();
  };

  const getData = async () => {
    setLoading(true);
    const response = await getDailyList(`?created_date=${createdDate}`);
    setTickets(response.data.tickets);
    setLoading(false);
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Carnesvilla | Reportes </title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title={"Carnesvilla"} breadcrumbItem={"Reportes"} />
          {loading ? (
            <Loader />
          ) : (
            <div className="d-flex justify-content-center">
              <Card
                style={{
                  width: "70rem",
                }}
              >
                <CardTitle className="ps-3 pt-3">
                  <h2 className="mb-3 font-size-20">Lista de firmas</h2>
                </CardTitle>
                <CardBody>
                  <Form onSubmit={onSubmit}>
                    <Row className="justify-content-md-start">
                      <Col lg={3}>
                        <p className="mb-1 font-size-13">Fecha:</p>
                        <Input
                          type="date"
                          className="form-control"
                          name="search"
                          id="search"
                          value={createdDate}
                          onChange={onChange}
                          placeholder="Código cliente..."
                        />
                      </Col>
                      <Col lg={6} className="mt-4">
                        <Button color="primary" type="submit">
                          Consultar
                        </Button>
                        {tickets.length > 0 && (
                          <Button
                            className="ms-2"
                            color="success"
                            type="button"
                            onClick={() =>
                              window.open(
                                `${URL}report/listadiaria_pdf/${createdDate}/`
                              )
                            }
                          >
                            Exportar
                          </Button>
                        )}
                      </Col>
                    </Row>
                  </Form>
                  <Row className="justify-content-md-center mt-2 mb-2">
                    <Col lg={12}>
                      <hr />
                    </Col>
                  </Row>
                  {tickets.length > 0 ? (
                    <Table
                      className="table table-striped table-borderless align-middle table-centered table-nowrap mb-4"
                      style={{
                        textAlign: "center",
                      }}
                    >
                      <thead className="table-light">
                        <tr>
                          <th>Código cliente</th>
                          <th>Cantidad bovinos</th>
                          <th>Firma</th>
                        </tr>
                      </thead>
                      <tbody>
                        {tickets.map((ticket, idx) => (
                          <tr key={idx}>
                            <th scope="row">{ticket.client}</th>
                            <td>{ticket.animal_number}</td>
                            <td>-</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  ) : (
                    <h3 className="card-title mb-4">
                      No se encontraron resultados
                    </h3>
                  )}
                </CardBody>
              </Card>
            </div>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default DailyList;
